module.exports = __webpack_public_path__ + "static/img/业务生态-产业人才培训-特色课程03-配图.82b91b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/业务生态-产业人才培训-特色课程03-配图.png
// module id = eCDU
// module chunks = 0